import { render, staticRenderFns } from "./ed-class-schedule-short-days-modal.component.vue?vue&type=template&id=2a06a6fa&scoped=true&"
import script from "./ed-class-schedule-short-days-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-schedule-short-days-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-schedule-short-days-modal.component.scss?vue&type=style&index=0&id=2a06a6fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06a6fa",
  null
  
)

export default component.exports